var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"load_wrap"}},[_c('div',{staticClass:"load"},[_c('lottie',{staticClass:"lottie",attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }